var _rect, _g, _circle;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
function SvgNotificationUnread(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 32,
    height: 32,
    viewBox: "0 0 32 32",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _rect || (_rect = /*#__PURE__*/React.createElement("rect", {
    width: 32,
    height: 32,
    rx: 4,
    fill: "#006CFA",
    fillOpacity: 0.1
  })), _g || (_g = /*#__PURE__*/React.createElement("g", {
    opacity: 0.5
  }, /*#__PURE__*/React.createElement("path", {
    d: "M16 23.5C17.3807 23.5 18.5 23.0523 18.5 22.5H13.5C13.5 23.0523 14.6193 23.5 16 23.5Z",
    fill: "#006CFA",
    stroke: "#006CFA",
    strokeWidth: 1.33333,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M8.66699 20.6667H23.3337",
    stroke: "#006CFA",
    strokeWidth: 1.33333,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M10.667 14.6666V20.6666H21.3337V14.6666C21.3337 11.7211 18.9458 9.33325 16.0003 9.33325C13.0548 9.33325 10.667 11.7211 10.667 14.6666Z",
    fill: "#006CFA",
    stroke: "#006CFA",
    strokeWidth: 1.33333,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M16 9.33341V8.66675",
    stroke: "#006CFA",
    strokeWidth: 1.33333,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  }))), _circle || (_circle = /*#__PURE__*/React.createElement("circle", {
    cx: 22,
    cy: 10,
    r: 3,
    fill: "#D7263D"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgNotificationUnread);
export default __webpack_public_path__ + "static/media/notification-unread.576e7b93310ed028607c65df8a8483b2.svg";
export { ForwardRef as ReactComponent };